import axios from 'axios';
import API_BASE_URL from '../config/api';
import authService from './authService';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const adminService = {
  async getSwitchableUsers(search = '') {
    try {
      const params = new URLSearchParams();
      if (search?.trim()) {
        params.append('search', search.trim());
      }

      const endpoint = params.toString()
        ? `/admin/users?${params.toString()}`
        : '/admin/users';
      const response = await api.get(endpoint);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch users';
    }
  },

  async impersonateUser(userId) {
    try {
      const response = await api.post('/admin/impersonate', { userId });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to impersonate user';
    }
  },

  async getSessionLogs(filters = {}) {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.status) params.append('status', filters.status);
      if (filters.email) params.append('email', filters.email);
      if (filters.from) params.append('from', filters.from);
      if (filters.to) params.append('to', filters.to);

      const query = params.toString();
      const endpoint = query ? `/admin/session-logs?${query}` : '/admin/session-logs';
      const response = await api.get(endpoint);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch session logs';
    }
  }
};

export default adminService;
